"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyleSet;

var _Activities = _interopRequireDefault(require("./StyleSet/Activities"));

var _Activity = _interopRequireDefault(require("./StyleSet/Activity"));

var _AdaptiveCardRenderer = _interopRequireDefault(require("./StyleSet/AdaptiveCardRenderer"));

var _AnimationCardAttachment = _interopRequireDefault(require("./StyleSet/AnimationCardAttachment"));

var _AudioAttachment = _interopRequireDefault(require("./StyleSet/AudioAttachment"));

var _AudioCardAttachment = _interopRequireDefault(require("./StyleSet/AudioCardAttachment"));

var _AudioContent = _interopRequireDefault(require("./StyleSet/AudioContent"));

var _Avatar = _interopRequireDefault(require("./StyleSet/Avatar"));

var _Bubble = _interopRequireDefault(require("./StyleSet/Bubble"));

var _CarouselFilmStrip = _interopRequireDefault(require("./StyleSet/CarouselFilmStrip"));

var _CarouselFlipper = _interopRequireDefault(require("./StyleSet/CarouselFlipper"));

var _ConnectivityNotification = _interopRequireDefault(require("./StyleSet/ConnectivityNotification"));

var _DictationInterims = _interopRequireDefault(require("./StyleSet/DictationInterims"));

var _DownloadAttachment = _interopRequireDefault(require("./StyleSet/DownloadAttachment"));

var _ErrorBox = _interopRequireDefault(require("./StyleSet/ErrorBox"));

var _ErrorNotification = _interopRequireDefault(require("./StyleSet/ErrorNotification"));

var _MicrophoneButton = _interopRequireDefault(require("./StyleSet/MicrophoneButton"));

var _Root = _interopRequireDefault(require("./StyleSet/Root"));

var _ScrollToEndButton = _interopRequireDefault(require("./StyleSet/ScrollToEndButton"));

var _SendBoxButton = _interopRequireDefault(require("./StyleSet/SendBoxButton"));

var _SendBox = _interopRequireDefault(require("./StyleSet/SendBox"));

var _SendBoxTextArea = _interopRequireDefault(require("./StyleSet/SendBoxTextArea"));

var _SendBoxTextBox = _interopRequireDefault(require("./StyleSet/SendBoxTextBox"));

var _SendStatus = _interopRequireDefault(require("./StyleSet/SendStatus"));

var _SingleAttachmentActivity = _interopRequireDefault(require("./StyleSet/SingleAttachmentActivity"));

var _SpinnerAnimation = _interopRequireDefault(require("./StyleSet/SpinnerAnimation"));

var _StackedLayout = _interopRequireDefault(require("./StyleSet/StackedLayout"));

var _SuggestedActions = _interopRequireDefault(require("./StyleSet/SuggestedActions"));

var _SuggestedActionsStyleSet = _interopRequireDefault(require("./StyleSet/SuggestedActionsStyleSet"));

var _SuggestedAction = _interopRequireDefault(require("./StyleSet/SuggestedAction"));

var _TextContent = _interopRequireDefault(require("./StyleSet/TextContent"));

var _Timestamp = _interopRequireDefault(require("./StyleSet/Timestamp"));

var _TypingActivity = _interopRequireDefault(require("./StyleSet/TypingActivity"));

var _TypingAnimation = _interopRequireDefault(require("./StyleSet/TypingAnimation"));

var _UploadButton = _interopRequireDefault(require("./StyleSet/UploadButton"));

var _VideoAttachment = _interopRequireDefault(require("./StyleSet/VideoAttachment"));

var _VideoContent = _interopRequireDefault(require("./StyleSet/VideoContent"));

var _VimeoContent = _interopRequireDefault(require("./StyleSet/VimeoContent"));

var _WarningNotification = _interopRequireDefault(require("./StyleSet/WarningNotification"));

var _YouTubeContent = _interopRequireDefault(require("./StyleSet/YouTubeContent"));

var _defaultStyleSetOptions = _interopRequireDefault(require("./defaultStyleSetOptions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createStyleSet(options) {
  options = _objectSpread({}, _defaultStyleSetOptions.default, options); // Keep this list flat (no nested style) and serializable (no functions)

  return {
    activities: (0, _Activities.default)(options),
    activity: (0, _Activity.default)(options),
    adaptiveCardRenderer: (0, _AdaptiveCardRenderer.default)(options),
    animationCardAttachment: (0, _AnimationCardAttachment.default)(options),
    audioAttachment: (0, _AudioAttachment.default)(options),
    audioCardAttachment: (0, _AudioCardAttachment.default)(options),
    audioContent: (0, _AudioContent.default)(options),
    avatar: (0, _Avatar.default)(options),
    bubble: (0, _Bubble.default)(options),
    carouselFilmStrip: (0, _CarouselFilmStrip.default)(options),
    carouselFlipper: (0, _CarouselFlipper.default)(options),
    connectivityNotification: (0, _ConnectivityNotification.default)(options),
    dictationInterims: (0, _DictationInterims.default)(options),
    downloadAttachment: (0, _DownloadAttachment.default)(options),
    errorBox: (0, _ErrorBox.default)(options),
    errorNotification: (0, _ErrorNotification.default)(options),
    microphoneButton: (0, _MicrophoneButton.default)(options),
    options: _objectSpread({}, options, {
      suggestedActionsStyleSet: (0, _SuggestedActionsStyleSet.default)(options)
    }),
    root: (0, _Root.default)(options),
    scrollToEndButton: (0, _ScrollToEndButton.default)(options),
    sendBox: (0, _SendBox.default)(options),
    sendBoxButton: (0, _SendBoxButton.default)(options),
    sendBoxTextArea: (0, _SendBoxTextArea.default)(options),
    sendBoxTextBox: (0, _SendBoxTextBox.default)(options),
    sendStatus: (0, _SendStatus.default)(options),
    singleAttachmentActivity: (0, _SingleAttachmentActivity.default)(options),
    spinnerAnimation: (0, _SpinnerAnimation.default)(options),
    stackedLayout: (0, _StackedLayout.default)(options),
    suggestedAction: (0, _SuggestedAction.default)(options),
    suggestedActions: (0, _SuggestedActions.default)(options),
    textContent: (0, _TextContent.default)(options),
    timestamp: (0, _Timestamp.default)(options),
    typingActivity: (0, _TypingActivity.default)(options),
    typingAnimation: (0, _TypingAnimation.default)(options),
    uploadButton: (0, _UploadButton.default)(options),
    videoAttachment: (0, _VideoAttachment.default)(options),
    videoContent: (0, _VideoContent.default)(options),
    vimeoContent: (0, _VimeoContent.default)(options),
    warningNotification: (0, _WarningNotification.default)(options),
    youTubeContent: (0, _YouTubeContent.default)(options)
  };
}